import { useEffect, useMemo, useState } from 'react';
import { AppHomeBannerFallback } from '@/utils/constants';
// import { AppWelcomebannerFallback } from '@/utils/constants';
import { useGetBannersQuery } from '@/store/api/bannerApi';
import { BannerResponse } from '@/types/banner';

const pickBanners = (src: any, key: string) =>
  src?.[key]
    ?.map((b: any) => ({ type: b.type, image: b.image }))
    .filter((banner: { image?: string }) => Boolean(banner.image)) || [];

export function useHomeBanner() {
  const { data: banners, isLoading: isBannersLoading } = useGetBannersQuery(undefined);

  // show Welcome Banner only once
  const [showWelcomeBanner, setShowWelcomeBanner] = useState(false);

  // banner groups
  const bannerGroups = banners?.data ?? banners ?? ({} as BannerResponse);
  const { AppBanner } = bannerGroups;
  const appHomeBannerImages = pickBanners(AppBanner, 'HomeBanner');
  const appWelcomeBannerImages = pickBanners(AppBanner, 'WellcomeBanner');

  // home banner
  const displayHomeBanner = useMemo(() => {
    if (isBannersLoading) return [];

    return appHomeBannerImages.length > 0 ? appHomeBannerImages : AppHomeBannerFallback;
  }, [appHomeBannerImages, isBannersLoading]);

  // welcome banner
  const displayWelcomeBanner = useMemo(() => {
    if (isBannersLoading) return [];

    return appWelcomeBannerImages;
    // return appWelcomeBannerImages.length > 0 ? appWelcomeBannerImages : AppWelcomebannerFallback;
  }, [appWelcomeBannerImages, isBannersLoading]);

  // welcome banner one-time logic
  useEffect(() => {
    const flag = localStorage.getItem('showWelcomeBanner');

    if (flag === 'true') {
      setShowWelcomeBanner(true);
      localStorage.setItem('showWelcomeBanner', 'false');
    }
  }, []);

  return {
    showWelcomeBanner,
    setShowWelcomeBanner,
    displayHomeBanner,
    displayWelcomeBanner,
    isBannersLoading,
  };
}
